import React from "react";

import useHub from "data/hub/useHub";

import { useFeatures } from "components/FeatureFlag";

import ClientCard from "scenes/Hubly/components/HubModals/components/ClientCard/ClientCard";

import { useWorkDesk, useWorkDeskEnabled } from "../hooks";

function WorkDeskPreloader() {
  const workDeskEnabled = useWorkDeskEnabled();
  const ffScreenManager = useFeatures("work-desk-screen-manager");
  const hub = useHub();
  const hubId = hub?.hubId;

  const {
    parentPathToIframePath,
    iframePathToWorkdeskParentPath,
    shouldShowWorkDesk,
    workDeskSyncEnabled,
  } = useWorkDesk();

  if (!workDeskEnabled) return null;
  // when the screen-manager layout is on, WorkDeskScreen owns the iframe
  if (ffScreenManager) return null;
  if (!hubId) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: "47px",
        left: "0px",
        width: "100vw",
        height: "calc(100vh - 57px)",
        backgroundColor: "white",
        zIndex: 109,
        overflow: "hidden",
        visibility: shouldShowWorkDesk ? "visible" : "hidden",
        pointerEvents: shouldShowWorkDesk ? "auto" : "none",
      }}
    >
      <ClientCard
        mapPathnameForIframeSrc={parentPathToIframePath}
        mapPathnameFromChild={iframePathToWorkdeskParentPath}
        syncEnabled={workDeskSyncEnabled}
      />
    </div>
  );
}

export default WorkDeskPreloader;
